import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=40318654&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=ts"
export * from "./AppModal.vue?vue&type=script&lang=ts"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=40318654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40318654",
  null
  
)

export default component.exports